'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record, List } from 'immutable';
import LinkCustomParams from 'MeetingsBase/models/LinkCustomParams';
import UserBusyTimes from 'MeetingsBase/models/UserBusyTimes';
import FormPrefills from 'MeetingsBase/models/FormPrefills';
import LinkAvailability from 'MeetingsBase/models/LinkAvailability';
var defaults = {
  allUsersBusyTimes: List(),
  bufferTime: 0,
  customParams: new LinkCustomParams(),
  linkId: null,
  linkType: null,
  userId: null,
  offline: false,
  openGates: List(),
  ownerPrioritized: null,
  inactive: false,
  formGuid: null,
  contentTracking: null,
  formPrefills: new FormPrefills(),
  linkAvailability: null,
  portalId: null
};

var PublicAvailabilityInfo = /*#__PURE__*/function (_Record) {
  _inherits(PublicAvailabilityInfo, _Record);

  function PublicAvailabilityInfo() {
    _classCallCheck(this, PublicAvailabilityInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(PublicAvailabilityInfo).apply(this, arguments));
  }

  _createClass(PublicAvailabilityInfo, [{
    key: "updateBusyTime",
    value: function updateBusyTime(jsonUserBusyTimes) {
      var updatedUserBusyTimes = UserBusyTimes.from(jsonUserBusyTimes);
      return this.update('allUsersBusyTimes', function (allUsersBusyTimes) {
        return allUsersBusyTimes.map(function (userBusyTimes) {
          if (userBusyTimes.id === updatedUserBusyTimes.id) {
            return updatedUserBusyTimes;
          }

          return userBusyTimes;
        });
      });
    }
  }], [{
    key: "from",
    value: function from(json) {
      var customParams = LinkCustomParams.from(json.customParams);
      var allUsersBusyTimes = List(json.allUsersBusyTimes.map(function (userBusyTimes) {
        return UserBusyTimes.from(userBusyTimes);
      }));
      var formPrefills = FormPrefills.from(json.formPrefills, customParams.get('formFields'));
      var linkAvailability = LinkAvailability.from(json.linkAvailability);
      return new PublicAvailabilityInfo({
        allUsersBusyTimes: allUsersBusyTimes,
        bufferTime: customParams.meetingBufferTime,
        linkId: json.linkId,
        linkType: json.linkType,
        userId: json.userId,
        customParams: customParams,
        offline: json.isOffline,
        openGates: List(json.openGates),
        ownerPrioritized: json.customParams.ownerPrioritized,
        inactive: json.inactive,
        formGuid: json.formGuid,
        contentTracking: json.contentTracking,
        formPrefills: formPrefills,
        linkAvailability: linkAvailability,
        portalId: json.portalId
      });
    }
  }]);

  return PublicAvailabilityInfo;
}(Record(defaults));

export { PublicAvailabilityInfo as default };